import camelcaseKeys from 'camelcase-keys'
import { create } from 'zustand'
import { supabase } from '../supabaseClient'
import useAuth from './useAuth'

export type SharedService = {
  id: string
  name: string
  title: string | null
  url: string | null
  authorizedEmails: string[] | null
}

interface SharedServicesState {
  services: SharedService[]
  loaded: boolean
  fetch: () => Promise<void>
  reset: () => void
}

const useSharedServices = create<SharedServicesState>(set => ({
  services: [],
  loaded: false,
  fetch: async () => {
    const email = useAuth.getState().user?.email
    if (!email) {
      set({ services: [], loaded: true })
      return
    }
    // Restrict to services that explicitly list the current user. Owner RLS would
    // otherwise return our own auth-required services too — and since that policy
    // stopped filtering tombstones, our own DELETED ones as well, hence the
    // deleted_at filter. The guest policy still excludes them on its own.
    const { data, error } = await supabase
      .from('services')
      .select('id, name, title, url, authorized_emails')
      .is('deleted_at', null)
      .eq('enabled', true)
      .eq('auth_required', true)
      .contains('authorized_emails', [email])
      .order('name')
    if (error) {
      console.warn('Shared services error:', error)
      set({ services: [], loaded: true })
      return
    }
    const services = (data ?? []).map(s => camelcaseKeys(s)) as SharedService[]
    set({ services, loaded: true })
  },
  reset: () => set({ services: [], loaded: false }),
}))

export default useSharedServices
